import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./sidebar";
import { TarefasVencidasDialog } from "@/components/dialogs/tarefas-vencidas/TarefasVencidasDialog";
import { useIsMobile } from "@/hooks/use-mobile";

import { cn } from "@/lib/utils";

const MainLayout: React.FC = () => {
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const mainRef = useRef<HTMLElement>(null);
  const { pathname } = useLocation();

  // O main é o único container de scroll e persiste entre rotas: sem isso a página nova herda o scroll da anterior
  useEffect(() => {
    mainRef.current?.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="relative flex h-screen w-full overflow-hidden bg-background font-sans text-foreground antialiased">
      <Sidebar isMobile={isMobile} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {isMobile && sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/80 backdrop-blur-sm transition-opacity animate-in fade-in"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div className="flex h-full flex-1 flex-col overflow-hidden">
        <Header isMobile={isMobile} onMenuClick={() => setSidebarOpen((prev) => !prev)} />

        <main
          ref={mainRef}
          className={cn(
            "custom-scrollbar flex-1 overflow-y-auto scroll-smooth",
            "bg-muted/5 px-3 py-4 md:px-6 md:py-6",
          )}
        >
          <Outlet />
        </main>
      </div>

      <TarefasVencidasDialog />
    </div>
  );
};

export default MainLayout;
